import { useSession } from 'contexts/session-context'
import Edit from 'icons/edit'
import { Link } from 'react-router-dom'
import { DivProfileTitle, PProfileTitle } from 'theme/profile'
import { TextProfile, TextProfileSecondary } from 'views/profile/text.style'

function Phone() {
  const [{ user }] = useSession()
  const name =
  user?.nickName ||
  (user?.firstName && user?.firstName.length > 20 ? user?.firstName.substring(0, 17) + '...' : user?.firstName)

  return (
    <>
      {user?.firstName && (
        <DivProfileTitle className="h-16 flex items-center px-10 w-screen">
          <PProfileTitle className="flex-grow  max-w-full">{name}</PProfileTitle>
        </DivProfileTitle>
      )}
      <div className="font-bold text-2xl px-10 py-8 pb-2 flex break-all">
        <div className="flex-1">
          <TextProfile>Numero de teléfono</TextProfile>
          {!user?.phoneNumber && !user?.address?.phone ? (
            <TextProfileSecondary className="font-normal dinPro text-lg normal-case">SIN INFORMACION</TextProfileSecondary>
          ) : (
            <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
              +52 {user?.address?.phone ? user?.address?.phone : user?.phoneNumber}
            </TextProfileSecondary>
          )}
        </div>
        <Link to="/phone/update" className="flex justify-start items-center">
          <button>
            <Edit />
          </button>
        </Link>
      </div>
      <div className="font-bold text-2xl px-10 py-4 flex break-all">
        <div className="flex-1">
          <TextProfile>Mail de contacto</TextProfile>
          <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
            {user?.contactEmail || 'SIN INFORMACION'}
          </TextProfileSecondary>
        </div>
        <Link to="/mail/update" className="flex justify-start items-center">
          <button>
            <Edit />
          </button>
        </Link>
      </div>
    </>
  )
}

export default Phone
